import { useEffect } from 'react';
import { useVibeModeDock } from '@/modules/VibeMode/hooks/useVibeModeDock';

const CSS_VARIABLE = '--vibe-dock-width';

export const useVibeModeDockLayoutOffset = () => {
    const { isDockOpen, dockWidth } = useVibeModeDock();

    useEffect(() => {
        const { style } = document.documentElement;

        style.setProperty(CSS_VARIABLE, isDockOpen ? `${dockWidth}px` : '0px');

        return () => {
            style.removeProperty(CSS_VARIABLE);
        };
    }, [dockWidth, isDockOpen]);
};
